import React from 'react';
import { ApolloQueryResult } from '@apollo/client';
import { EntitlementDetails, BillingFrequency } from '@css-xp/graphtypes/src/generated-types-new';
import { NextBillDate as NextBillDateComp } from '@css-xp/ppc-common';
import { ADVOCATE_ACCESS_TYPE, ADVOCATE_RESOURCE_TYPE, useAdvocateAccessControl } from '@css-xp/ppc-access-control';
import './next-bill-date.scss';

export const NextBillDate = ({
  entitlement,
  refetch,
}: {
  entitlement: EntitlementDetails;
  refetch: () => Promise<ApolloQueryResult<unknown>>;
}) => {
  const canAdvocatesManageSubscription = useAdvocateAccessControl({
    accessType: ADVOCATE_ACCESS_TYPE.UPDATE,
    resource: ADVOCATE_RESOURCE_TYPE.SUBSCRIPTION,
  });
  return (
    <NextBillDateComp
      entitlement={entitlement}
      refetch={refetch}
      hideChangeBillDateButton={
        !canAdvocatesManageSubscription || entitlement?.billingFrequency === BillingFrequency.ANNUAL
      }
    />
  );
};
